


(function () {
	'use strict';

	var STORAGE_KEY = 'bloom_cookie_consent_v1';
	var CONSENT_VERSION = 1;

	
	window.dataLayer = window.dataLayer || [];
	window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

	
	var stored = null;
	try {
		var raw = window.localStorage.getItem(STORAGE_KEY);
		if (raw) {
			var parsed = JSON.parse(raw);
			if (parsed && typeof parsed === 'object' && parsed.version === CONSENT_VERSION) stored = parsed;
		}
	} catch (e) {}

	var analyticsGranted = !!(stored && stored.analytics === true);
	var marketingGranted = !!(stored && stored.marketing === true);

	

	
	var marketingCbs = [];
	var analyticsCbs = [];

	function persist(analytics, marketing) {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
				analytics: !!analytics,
				marketing: !!marketing,
				timestamp: new Date().toISOString(),
				version:   CONSENT_VERSION
			}));
		} catch (e) {}
	}

	function syncShopify(analytics, marketing) {
		try {
			if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
				window.Shopify.customerPrivacy.setTrackingConsent({
					analytics:    !!analytics,
					marketing:    !!marketing,
					preferences:  false,
					sale_of_data: !!marketing
				}, function () {});
			}
		} catch (e) {}
	}

	window.BloomConsent = {
		state: {
			analytics: analyticsGranted,
			marketing: marketingGranted,
			decided:   !!stored,
			timestamp: stored ? stored.timestamp : null
		},
		hasAnalyticsConsent: function () { return this.state.analytics === true; },
		hasMarketingConsent: function () { return this.state.marketing === true; },
		hasDecided:          function () { return this.state.decided === true; },
		onMarketingGranted: function (cb) {
			if (typeof cb !== 'function') return;
			if (this.state.marketing) { try { cb(); } catch (e) {} return; }
			marketingCbs.push(cb);
		},
		onAnalyticsGranted: function (cb) {
			if (typeof cb !== 'function') return;
			if (this.state.analytics) { try { cb(); } catch (e) {} return; }
			analyticsCbs.push(cb);
		},
		
		update: function (analytics, marketing) {
			analytics = !!analytics;
			marketing = !!marketing;

			var marketingFresh = !this.state.marketing && marketing;
			var analyticsFresh = !this.state.analytics && analytics;

			this.state.analytics = analytics;
			this.state.marketing = marketing;
			this.state.decided   = true;
			this.state.timestamp = new Date().toISOString();

			persist(analytics, marketing);

			

			syncShopify(analytics, marketing);

			if (marketingFresh) {
				var mc = marketingCbs.slice(); marketingCbs.length = 0;
				for (var i = 0; i < mc.length; i++) { try { mc[i](); } catch (e) {} }
			}
			if (analyticsFresh) {
				var ac = analyticsCbs.slice(); analyticsCbs.length = 0;
				for (var j = 0; j < ac.length; j++) { try { ac[j](); } catch (e) {} }
			}

			try {
				document.dispatchEvent(new CustomEvent('bloom:consent:updated', {
					detail: { analytics: analytics, marketing: marketing }
				}));
			} catch (e) {}
		}
	};

	
	if (stored) syncShopify(analyticsGranted, marketingGranted);
})();


(function () {
	'use strict';

	var UI_SRC = '//bloomperfume.co.uk/cdn/shop/t/4/assets/cookie-consent-ui.js?v=83258311402520499571782044960';
	var uiReady = null, uiQueue = [], uiLoading = false;

	
	window.__bloomCCRegister = function (api) {
		uiReady = api;
		var q = uiQueue.slice(); uiQueue.length = 0;
		for (var i = 0; i < q.length; i++) { try { q[i](api); } catch (e) {} }
	};

	function whenUI(cb) {
		if (uiReady) { try { cb(uiReady); } catch (e) {} return; }
		if (cb) uiQueue.push(cb);
		if (uiLoading) return;
		uiLoading = true;
		var s = document.createElement('script');
		s.src = UI_SRC;
		s.async = true;
		s.onerror = function () { uiLoading = false; };
		document.head.appendChild(s);
	}

	
	if (window.BloomConsent && !window.BloomConsent.hasDecided()) {
		whenUI(function (api) { api.showBanner(); });
	}

	
	document.addEventListener('click', function (e) {
		var t = e.target.closest('[data-cookie-preferences], a[href="#cookie-preferences"], a[href$="#cookie-preferences"]');
		if (!t) return;
		e.preventDefault();
		whenUI(function (api) { api.openModal(); });
	});
	window.openCookiePreferences = function () { whenUI(function (api) { api.openModal(); }); };
})();
